export const BillingHomePath = '/billing';
export const BillingInvoiceListPath = '/billing/invoices';
export const BillingInvoiceDetailsPath = {
  path: '/billing/invoices/:invoiceId',
  withId: (invoiceId: string): string => {
    return BillingInvoiceDetailsPath.path.replace(':invoiceId', invoiceId);
  },
};
export const BillingDetailsEditPath = '/billing/details/edit';
export const BillingUpgradePlanPath = '/billing/upgrade';
export const BillingUpgradePlanPaymentSetupPath = '/billing/upgrade/payment-setup';
export const BillingPaymentMethodListPath = '/billing/payment-methods';
export const BillingPaymentMethodAddPath = '/billing/payment-methods/add';
